import React, { useState } from 'react';
import { db } from '../services/firebase';
import { collection, addDoc, serverTimestamp, getDocs } from 'firebase/firestore';
import styles from './WaitingListPage.module.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CountryPhoneInput from '../components/Admin/CountryPhoneInput';

const WaitingListPage = () => {
    const [formData, setFormData] = useState({ name: '', numPeople: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [phoneData, setPhoneData] = useState({ country: { name: 'Qatar', code: '974', flag: '🇶🇦' }, phone: '' });

    const { name, numPeople } = formData;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !phoneData.phone || !numPeople) {
            setError('Please fill out all fields.');
            setSuccessMessage('');
            return;
        }
        setLoading(true);
        setError('');
        setSuccessMessage('');

        try {
            // Add the new entry to the waiting list
            await addDoc(collection(db, 'waitingList'), {
                name,
                phone: `+${phoneData.country.code}${phoneData.phone}`,
                numPeople: parseInt(numPeople, 10),
                createdAt: serverTimestamp(),
            });

            // Set a generic success message
            setSuccessMessage("You've been added to the list! We'll message you on WhatsApp when a table is ready.");
            
            setFormData({ name: '', numPeople: '' });
            setPhoneData({ country: { name: 'Qatar', code: '974', flag: '🇶🇦' }, phone: '' });
        } catch (err) {
            console.error('Error adding to waiting list:', err);
            setError('Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1 className={styles.title}>Join the Waiting List</h1>
                    <p className={styles.subtitle}>
                        We will notify you on WhatsApp as soon as there is seat available.
                    </p>
                    
                    {!successMessage ? (
                        <form onSubmit={handleSubmit} className={styles.form} noValidate style={{
                            background: '#fff',
                            borderRadius: 18,
                            boxShadow: '0 4px 32px rgba(0,0,0,0.07)',
                            padding: '32px 20px',
                            maxWidth: 420,
                            margin: '0 auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                        }}>
                            <input
                                type="text"
                                name="name"
                                value={name}
                                onChange={handleChange}
                                placeholder="Enter your name"
                                className={styles.input}
                                required
                                aria-label="Your name"
                                style={{
                                    fontSize: 17,
                                    borderRadius: 16,
                                    border: '1px solid #ddd',
                                    padding: '16px',
                                    background: '#fafafa',
                                    height: 56,
                                    boxSizing: 'border-box',
                                }}
                            />
                            <CountryPhoneInput
                                value={phoneData}
                                onChange={setPhoneData}
                                aria-label="Phone number with country code"
                            />
                            <input
                                type="number"
                                name="numPeople"
                                value={numPeople}
                                onChange={handleChange}
                                placeholder="Number of people"
                                className={styles.input}
                                required
                                min="1"
                                aria-label="Number of people"
                                style={{
                                    fontSize: 17,
                                    borderRadius: 16,
                                    border: '1px solid #ddd',
                                    padding: '16px',
                                    background: '#fafafa',
                                    height: 56,
                                    boxSizing: 'border-box',
                                }}
                            />
                            <button type="submit" className={styles.button} disabled={loading} aria-busy={loading} style={{
                                fontWeight: 700,
                                fontSize: 18,
                                borderRadius: 12,
                                padding: '14px 0',
                                background: '#111',
                                color: '#fff',
                                border: 'none',
                                marginTop: 8,
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'background 0.2s',
                            }}>
                                {loading ? 'Joining...' : 'Join Now'}
                            </button>
                            {error && <div role="alert" className={styles.error} style={{ color: '#c00', marginTop: 8, textAlign: 'center', fontWeight: 500, fontSize: 16, background: '#fff3f3', borderRadius: 8, padding: '8px 0' }}>{error}</div>}
                        </form>
                    ) : (
                        <div className={styles.successContainer} style={{
                            background: '#eaffea',
                            borderRadius: 14,
                            padding: '32px 20px',
                            maxWidth: 420,
                            margin: '0 auto',
                            textAlign: 'center',
                        }}>
                            <h2 className={styles.successTitle} style={{ color: '#1a7f37', fontWeight: 700, fontSize: 22, marginBottom: 10 }}>Success!</h2>
                            <p className={styles.successMessage} style={{ color: '#1a7f37', fontSize: 17 }}>{successMessage}</p>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default WaitingListPage; 